
import { Component, Vue } from 'vue-property-decorator'
import { getPayMode, getTodayPayMode, setPayMode } from '@/api'
import _ from 'lodash'
import { setTimeout } from 'timers'
import moment from 'moment'

@Component({
  name: 'PayMode'
})
export default class extends Vue {
  payMode:any = {
    week: [],
    day: []
  }
  datePickerRst = []
  weekKeyList = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
  backOptions = [{
    value: 'cmb',
    label: '招商银行'
  }, {
    value: 'uccb',
    label: '乌鲁木齐银行'
  }]

  async mounted() {
    await this.initData()
  }
  async initData() {
    const { data } = await getPayMode()
    if (data) {
      this.payMode = JSON.parse(data.value)
    } else {
      this.payMode = {
        week: [],
        day: []
      }
    }
  }
  async onCommitTap() {
    let self = this
    this.$confirm('请确认是否提交？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonClass: 'el-button--danger',
      type: 'warning'
    }).then(async() => {
      await setPayMode({
        Mode: JSON.stringify(this.payMode)
      })
      self.$notify({
        title: '成功',
        message: '提交成功',
        type: 'success',
        duration: 2000
      })
      await this.initData()
    }).catch(() => {

    })
    console.log(this.payMode)
  }
  onDatePickerChange() {
    this.calPayModeDay(this.datePickerRst)
    this.datePickerRst = []
  }
  calPayModeDay(data:any) {
    for (let item of data) {
      const dateStr:any = `${item.getFullYear()}-${item.getMonth() + 1}-${item.getDate()}`
      if (!this.payMode.day.includes(dateStr)) {
        this.payMode.day.push(dateStr)
      }
    }
    this.sortPayModeDay()
  }
  sortPayModeDay() {
    this.payMode.day.sort(function(a:any, b:any) {
      return Date.parse(a) - Date.parse(b)
    })
  }
  onDateDel(idx:any) {
    let self = this
    this.$confirm(`是否删除${this.payMode.day[idx]}？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonClass: 'el-button--danger',
      type: 'warning'
    }).then(() => {
      self.payMode.day.splice(idx, 1)
    })
  }
}
